import React, { useContext, useMemo } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import PropTypes from 'prop-types';
import { Text } from '@bingads-webui-react/fabric-control';
import { PropertyRow } from '@bingads-webui-campaign-react/ui-generator';

export const CostPerSale = ({ data }) => {
  const i18n = useContext(I18nContext);

  const { costPerSaleOptOut } = data || {};

  const costPerSaleSummary = useMemo(() => {
    if (costPerSaleOptOut) {
      return i18n.getString(_TL_('Off'));
    }
    return i18n.getString(_TL_('On'));
  }, [i18n, costPerSaleOptOut]);

  return (
    <PropertyRow propertyLabel={{ label: _TL_('Cost per sale') }}>
      <Text>{costPerSaleSummary}</Text>
    </PropertyRow>
  );
};

CostPerSale.propTypes = {
  data: PropTypes.shape({
    costPerSaleOptOut: PropTypes.bool,
  }),
};

CostPerSale.defaultProps = {
  data: {},
};
